
ACC.forgotpassword = {

  bindAll: function() {
    this.bindForgotPasswordLink($('.password-forgotten'));

    $(document).on('click', '.ph-forgotpwd-popup-close', function() {
      $.colorbox.close();
    });

    $(document).on('click', '.ph-passwordSubmit', function() {
      var emailId = $('#forgottenPwdEmail').val(),
          emailFormatInvalid = ACC.validation.email($.trim(emailId)),
          inputLabel = $('#forgottenPwdForm').find('.ph-formlabel'),
          diffUrl = $('#diffUrl').val();

      $('#forgotPasswordMailid').val(emailId);

      if (emailFormatInvalid) {
        inputLabel.html($(document).find('#invalidErrorMessage').text());
        inputLabel.addClass('ph-error-important');
      } else {
        inputLabel.html($(document).find('#LabelMessage'));
        inputLabel.removeClass('ph-error-important');
        $.ajax({
          url: ACC.config.contextPath + '/login/pw/emailIDCheck',
          type: 'GET',
          data: {
            emailId: emailId,
            diffUrl: diffUrl
          },
          async: false,
          dataType: 'json',
          success: function() {
            ACC.forgotpassword.validEmailPopup();
          }
        });
      }
    });
  },

  validEmailPopup: function() {
    $.colorbox({
      inline: true,
      href: '#validEmailPopup',
      width: '100%',
      maxHeight: '400px',
      maxWidth: '522px',
      close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
      overlayClose: false,
      onLoad: function() {
        $(document).find('#forgottenPwdForm').ajaxSubmit();
        $(document).find('.ph-forgottenPwd__mailid').text($(document).find('#forgotPasswordMailid').val());
      },
      onComplete: function() {
        $(document).find('.ph-forgottenPwd__mailid').text($(document).find('#forgotPasswordMailid').val());
        ACC.common.refreshScreenReaderBuffer();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },

  bindForgotPasswordLink: function(link) {
    link.click(function() {
      var isFrenchCa = $('body').is('.ph-store-hhs-philips-ca.language-fr');
      var maxWidth = '522px';

      if (isFrenchCa) {
        maxWidth = '600px';
      }

      $.get(link.data('url')).done(function(data) {
        $.colorbox({
          html: data,
          width: '100%',
          maxHeight: '400px',
          maxWidth: maxWidth,
          close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
          overlayClose: false,
          onOpen: function() {
            $('#validEmail').remove();
          },
          onComplete: function() {
            if (isFrenchCa) {
              $('#forgottenPwdForm .ph-passwordSubmit').parent().removeClass('ph-d-block').addClass('ph-d-flex').css({
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '16px 33px'
              });
              $('#forgottenPwdForm .ph-forgottenPwd__link').removeClass('ph-ml-3');
              $.colorbox.resize();
            }

            ACC.common.refreshScreenReaderBuffer();
            $('#diffUrl').attr('value', false);
          },
          onClosed: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      });
    });
  }
};

$(document).ready(function() {
  ACC.forgotpassword.bindAll();
});
